import { PageEventFragment } from 'types/api/dato-operations.types';

import { processDateTime } from 'components/@events/utils';

import MultiDayDateTime from './MultiDayDateTime';
import SingleDayDateTime from './SingleDayDateTime';

interface Props {
  startDatetime: PageEventFragment['startDatetime'];
  endDatetime: PageEventFragment['endDatetime'];
  timezone: PageEventFragment['timezone'];
}

const FormattedDateTime = ({ startDatetime, endDatetime, timezone }: Props) => {
  if (!startDatetime || !endDatetime || !timezone) return undefined;

  const { zonedStartDate, updatedZonedEndDate, isSingleDay } = processDateTime(
    startDatetime,
    endDatetime,
    timezone,
  );

  const DateTimeComponent = isSingleDay ? SingleDayDateTime : MultiDayDateTime;

  // Shorter than a day: e.g. TUE 30 JAN • 10:00 AM - 12:00 PM
  // Longer than a day: e.g.  TUE 30 JAN - FRI 02 FEB

  return (
    <div>
      <DateTimeComponent
        updatedZonedEndDate={updatedZonedEndDate}
        zonedStartDate={zonedStartDate}
      />
    </div>
  );
};

export default FormattedDateTime;
